import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/typings';

const selectProfileState = (state: RootState) => state.profile;

const selectAchievementsState = (state: RootState) =>
  state.profile.achievementsState;

const selectShowcaseState = (state: RootState) => state.profile.showcaseState;

export const selectUserTotalXp = createSelector(
  selectAchievementsState,
  (achievementsState) => achievementsState.totalXp,
);

export const selectUserTotalBp = createSelector(
  selectAchievementsState,
  (achievementsState) => achievementsState.totalBp,
);

export const selectAchievements = createSelector(
  selectAchievementsState,
  (achievementsState) => achievementsState.achievements,
);

export const selectPublishedShowcases = createSelector(
  selectShowcaseState,
  (showcase) => showcase.publishedShowcases,
);

export const selectGenericApplets = createSelector(
  selectShowcaseState,
  (showcase) => showcase.genericApplets,
);

export const selectUploadFileGenericApplet = createSelector(
  selectGenericApplets,
  (genericApplets) =>
    genericApplets.find((applet) => applet.type === 'generic-upload-file'),
);

export const selectRichTextGenericApplet = createSelector(
  selectGenericApplets,
  (genericApplets) =>
    genericApplets.find((applet) => applet.type === 'generic-rich-text'),
);

export const selectAchievementsLength = createSelector(
  selectAchievements,
  (achievementsState) => achievementsState?.length || 0,
);

export const selectProfileMenuSelected = createSelector(
  selectProfileState,
  (profileState) => profileState.profileMenuSelected,
);

export const selectPublishedShowcasesLength = createSelector(
  selectShowcaseState,
  (showcase) => showcase.publishedShowcases?.length || 0,
);

export const sortModeSelect = createSelector(
  selectProfileState,
  (profileState) => profileState.sortByMode,
);

const selectShowcaseTemplates = createSelector(
  selectProfileState,
  (profileState) => profileState.showcaseTemplates,
);

export const selectShowcaseTemplateByDefault = createSelector(
  selectShowcaseTemplates,
  (showcaseTemplates) => showcaseTemplates[0]
);

export const selectAchievementChallenge = createSelector(
  selectAchievements,
  (achievements) => achievements?.filter(achievement => achievement.type === 'CHALLENGE')
);

export const selectAchievementByChallenge = (appletId: string) => createSelector(
  selectAchievementChallenge,
  (achievementsFiltered) => {
    return achievementsFiltered?.find(achievement => achievement.appletIds?.find(id => id === appletId))
  }
);

export const alphaDirectionSelect = createSelector(
  selectProfileState,
  (profileState) => profileState.alphaDirection,
);
